import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "A vs. B",
  description:
    "A manufacturer of a hairdryer is interested in the acoustic quality of different products. For this, binaural recordings of hairdryers were made. In a rather simple listening test design the participants are asked about preference of three different products.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0224-tests/avsb.html`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  direction: "row",
                  size: "large-thin",
                  color: "primary",
                  data:
                    "For each step, two out of the three recordings of the three hairdryers are assigned to A and B in all possible permutations. This helps to detect inappropriate or inconsistent answering behaviour.",
                },
              },
              styles: {
                padding: "0 9.5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
